class ProductRecently extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector('[data-product-recently]');
    this.slidable = this.dataset.slidable;
    const handle = this.dataset.handle;
    const limit = this.dataset.limit;

    if (this.slidable === 'true') {
      this.slider = this.querySelector('slider-component');
    }
    if (handle !== '' && handle !== undefined) {
      this.add(handle, limit);
      this.show(handle);
    }
  }

  add(handle, limit) {
    let data = localStorage.getItem('product-recently');
    if (data !== null && data !== '[]' && data !== '[null]') {
      data = JSON.parse(data);
    } else {
      data = [];
    }
    const index = data.indexOf(handle);
    if (index !== -1) {
      data.splice(index, 1); // Remove existing product to reorder
    }
    data.push(handle); // Add new product
    if (data.length > parseInt(limit, 10)) {
      data = data.slice(-parseInt(limit, 10)); // Limit to the most recent
    }
    localStorage.setItem('product-recently', JSON.stringify(data));
  }

  show(handle) {
    const session = localStorage.getItem('product-recently');
    if (session !== null && session !== '[]' && session !== '[null]') {
      const products = JSON.parse(session);
      if (products.length === 1) {
        this.classList.add('hidden');
      }
      this.content.classList.add('is-loading');
      this.showContent(products, handle);
    }
  }

  async showContent(products, handle) {
    let productLoaded = false; // Track if at least one product loads
    for (let i = 0; i < products.length; i++) {
      if (products[i] && products[i] !== handle) {
        const url = `/products/${products[i]}?view=item`;
        await $.get(url, (html) => {
          productLoaded = true; // A product successfully loaded
          if (this.slidable === 'true') {
            $(`<div class="swiper-slide col product-item__content product-item__content-${i}" data-carousel-item></div>`).appendTo($(this.content));
          } else {
            $(`<div class="col product-item__content product-item__content-${i}"></div>`).appendTo($(this.content));
          }
          const innerHTML = this.content.querySelector(`.product-item__content-${i}`);
          $(html).appendTo($(innerHTML));
          if (i === products.length - 1 || productLoaded) {
            this.content.classList.remove('is-loading');
            if (this.slidable === 'true' && this.slider && typeof this.slider.init === 'function') {
              this.slider.init();
            }
          }
        }).fail(() => {
          console.warn(`Product ${products[i]} is invalid or unavailable.`);
          products.splice(i, 1);
          localStorage.setItem('product-recently', JSON.stringify(products));
        });
      }
    }
    if (!productLoaded) {
      this.content.classList.remove('is-loading'); // Ensure loading class is removed even if no product loads
    }
  }
}

customElements.define('product-recently', ProductRecently);
